<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="'推广佣金记录' + props.userName" width="85%" :open="true" :confirmLoading="state.loading"
        :maskClosable="false" @ok="onFormSubmit" @cancel="cancel" :footer="null">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="6" :sm="24">
                            <a-form-item label="平台">
                                <PlatformPick v-model:value="queryParam.platform_id"></PlatformPick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="下级用户">
                                <a-input v-model:value="queryParam.nickname" placeholder="代理商姓名或手机号"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="创建时间">
                                <BetweenTimePick v-model:value="queryParam.between_time"></BetweenTimePick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-row>
                <a-col :md="4" :sm="24">
                    <a-statistic title="本页共计产生佣金（元）" :precision="2" :value="state.sumAmount" />
                </a-col>
                <a-col :md="6" :sm="24" style="display: flex" v-if="!props.order_ids">
                    <a-statistic title="已提现总佣金（元）" :precision="2" :value="state.sumAmountAllCatched" />
                </a-col>
                <a-col :md="14" :sm="24" style="display: flex" v-if="!props.order_ids">
                    <a-statistic title="未提现总佣金（元）=" :precision="2" :value="state.sumAmountAll" />
                    <a-statistic title="暂不可提现佣金（元）+" :precision="2" :value="state.sumAmountAll1" />
                    <a-statistic title="结算中佣金（元）+" :precision="2" :value="state.sumAmountAll3" />
                    <a-statistic title="可提现佣金（元）" :precision="2" :value="state.sumAmountAll2" style="float: left" />
                    <a-button type="primary" @click="tixian" style="margin-top: 25px; margin-left: 10px">提现</a-button>
                </a-col>
            </a-row>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id">
                <template #headerCell="{ column }">
                    <template v-if="column.dataIndex === 'dealer_shouyi'">
                        <span>
                            我的结算佣金(元) <a-tooltip title="佣金=实付-应付-技术服务费">
                                <InfoCircleOutlined />
                            </a-tooltip></span>
                    </template>
                </template>
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'order_number'">
                        {{ text }}
                        <div v-if="record.is_refund == 1">当前订单有退款待审核中</div>
                        <div v-if="record.is_refund == 2">已退款</div>
                        <div v-if="record.is_refund == 3">已撤销</div>
                        <div>{{ record.order_name }}</div>
                    </template>
                    <template v-else-if="column.dataIndex === 'payment_method'">
                        <div v-if="record.type == 2 && record.action == 'address'">预收款结转-库存地址结转收款</div>
                        <div v-else-if="record.type == 2 && record.action == 'walletRecharge'">预收款结转-余额结转收款</div>
                        <div v-else>
                            <WechatOutlined v-if="record.action == 'wechatPay'" />{{ paymentMethod.get(text) }} 手续费：{{
                                record.shouxu_money }}元
                        </div>
                    </template>
                    <template v-else-if="column.dataIndex === 'platform_money2'">
                        <div>{{ record.platform_money - record.dealer_money }}元</div>
                    </template>
                    <template v-else-if="column.dataIndex === 'settlement_dealer_status'">
                        <div v-if="record.settlement_dealer_status == 1">
                            <p><a-tag color="green">已结算</a-tag></p>
                            <p style="font-size: 12px">{{ record.settlement_dealer_time }}</p>
                        </div>
                        <div v-else-if="record.settlement_dealer_status == 2">
                            <a-tag color="orange" style="font-size: 12px">未结算</a-tag>
                        </div>
                        <div v-else-if="record.settlement_dealer_status == 3">
                            <a-tag color="blue">结算审核中</a-tag>
                        </div>
                    </template>
                    <template v-else-if="column.dataIndex === 'settlement_service_status'">
                        <div v-if="record.settlement_service_status == 1">
                            <p><a-tag color="green">已结算</a-tag></p>
                            <p style="font-size: 12px">{{ record.settlement_service_time }}</p>
                        </div>
                        <div v-else-if="record.settlement_service_status == 2">
                            <a-tag color="orange" style="font-size: 12px">未结算</a-tag>
                        </div>
                        <div v-else-if="record.settlement_service_status == 3">
                            <a-tag color="blue">结算审核中</a-tag>
                        </div>
                    </template>
                </template>
            </a-table>
        </a-card>
        <TixianForm v-if="state.tixianVisible" :platformId="state.tixianPlatformId"
            :betweenTime="state.tixianBetween_time" @cancel="onCancel" @ok="onOk">
        </TixianForm>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import BetweenTimePick from '@/components/base/BetweenTimePick.vue'
import PlatformPick from '@/components/base/PlatformPick.vue'
import TixianForm from './TixianForm.vue'
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    userId: {
        type: Number,
        default: null
    },
    userName: {
        type: String,
        default: ''
    },
    order_ids: {
        type: Object,
        default: () => null
    }
})
const columns = [
    {
        title: '订单编号、名称',
        dataIndex: 'order_number'
    },
    {
        title: '收款人、收款方式、手续费',
        dataIndex: 'payment_method'
    },
    {
        title: '流水(实付)(元)',
        dataIndex: 'actually_paid_money'
    },
    {
        title: '下级拿货价(元)',
        dataIndex: 'platform_money'
    },
    {
        title: '我的拿货价(元)',
        dataIndex: 'platform_money2'
    },
    {
        title: '服务商结算状态',
        dataIndex: 'settlement_service_status'
    },
    {
        title: '推广佣金(元)',
        dataIndex: 'dealer_shouyi'
    },
    {
        title: '我的结算状态',
        dataIndex: 'settlement_dealer_status'
    },
    {
        title: '该单代理商',
        dataIndex: 'nickname'
    },
    {
        title: '发生时间',
        dataIndex: 'created_at'
    }
]
const paymentMethod = new Map([
    [0, '未知'],
    [1, '对公'],
    [2, '微信'],
    [3, '支付宝'],
    [4, '银行卡'],
    [5, '其他'],
    [6, '返点转余额'],
    [7, '现金'],
    [8, '微信支付']
])
interface state {
    loading: boolean
    detailData: object
    sumAmount: number
    sumAmountAll: number
    sumAmountAll1: number
    sumAmountAll2: number
    sumAmountAll3: number
    sumAmountAllCatched: number
    tixianVisible: boolean
    tixianPlatformId: number
    tixianBetween_time: string
}
const state = reactive<state>({
    loading: false,
    detailData: {},
    sumAmount: 0, //本页共计流水
    sumAmountAll: 0, //全部未提佣金
    sumAmountAll1: 0, //未结账
    sumAmountAll2: 0, //已结账
    sumAmountAll3: 0, //结算中
    sumAmountAllCatched: 0, //全部已提佣金
    tixianVisible: false,
    tixianPlatformId: 0,
    tixianBetween_time: '',
})
let queryParam = reactive<any>({
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/tuiguangOrder/list',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, sonId: props.userId, order_ids: props.order_ids }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.total_records
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
        state.sumAmountAll = res.data.sum_amount_all
        state.sumAmountAll1 = res.data.sum_amount_all1
        state.sumAmountAll2 = res.data.sum_amount_all2
        state.sumAmountAll3 = res.data.sum_amount_all3
        state.sumAmountAllCatched = res.data.sum_amount_all_catched
        //统计本页金额
        state.sumAmount = 0
        dataSource.value.forEach((item: any) => {
            state.sumAmount += item.dealer_shouyi * 1
        })
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const onFormSubmit = () => {
    emit('cancel')
}
const cancel = () => {
    emit('cancel')
}
//提交操作
const tixian = () => {
    if (!queryParam.platform_id) {
        message.error('请选择平台')
        return
    }
    if (queryParam.platform_id.length != 1) {
        message.error('请选择一个平台')
        return
    }
    if (!queryParam.between_time) {
        message.error('请选择时间范围')
        return
    }
    state.tixianVisible = true
    state.tixianPlatformId = queryParam.platform_id[0]
    state.tixianBetween_time = queryParam.between_time
}
const onCancel = () => {
    state.tixianVisible = false
}
const onOk = () => {
    state.tixianVisible = false
    loadData()
}
</script>
<style lang="less" scoped></style>
